import { Alert, Dialog, Typography } from "@mui/material";
import React from "react";
import { DialogContent, DialogTitle } from "../dialog";

type WarningsDialogProps = {
  onClose: () => void;
  open: boolean;
  warnings: string[];
};

export default function WarningsDialog({
  onClose,
  open,
  warnings,
}: WarningsDialogProps) {
  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle onClose={onClose}>
        <Typography variant="h6" gutterBottom component="div">
          Warnings
        </Typography>
      </DialogTitle>
      <DialogContent>
        {warnings.map((warning, index) => (
          <Alert key={index} severity="warning">
            {warning}
          </Alert>
        ))}
      </DialogContent>
    </Dialog>
  );
}
